module.exports = __webpack_public_path__ + "light-repeating3.svg?b3d0764c76220ffaff25ab3fa38640bd";